import { render, staticRenderFns } from "./D.vue?vue&type=template&id=2df75352&"
import script from "./D.vue?vue&type=script&lang=js&"
export * from "./D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df75352')) {
      api.createRecord('2df75352', component.options)
    } else {
      api.reload('2df75352', component.options)
    }
    module.hot.accept("./D.vue?vue&type=template&id=2df75352&", function () {
      api.rerender('2df75352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/configurator/D.vue"
export default component.exports